import { useState } from "react";
import "./PageLoading.scss"
import { useEffect } from "react";
import Config from "@/src/branding/dream-4k/Config";

const PageLoading = ({ className = "", isVisible = false, type = '' }) => {

    const [isShow, setIsShow] = useState(isVisible);

    useEffect(() => {

        if (isVisible) {
            setIsShow(true);
        } else {

            setTimeout(() => {

                requestAnimationFrame(() => {
                    setIsShow(false);
                });

            }, 50);

        }

    }, [isVisible]);

    if (!isShow) return null;

    return (
        <div className={`page-loading bg-cover  ${className}`} style={type != 'player' ? { backgroundImage: `url(${Config.AppBackground})` } : {}} >
            <div className="page-loading-loader"></div>
        </div>
    )

}

export default PageLoading;